import { DocImgBaseUrl } from "../../utils/configurable";
import dayjs from "dayjs";
import useDocumentViewer from "../../hooks/documentPreview/useDocumentPreview";
import { PlayCircleFilled } from "@ant-design/icons";

const ShowImage = ({ showDataAcc, fileType }) => {
  const { onFilterDocClick } = useDocumentViewer();

  return (
    <>
      <div>
        {fileType != "recent" && <h3 className="date_image">{dayjs(showDataAcc?.created_at).format("MMMM YYYY")}</h3>}
        <div className="ib_item" onKeyDown={(e) => e.preventDefault()}>
          {fileType == "recent" ? (
            <>
              <div
                className="img_box"
                onDoubleClick={() => onFilterDocClick(showDataAcc?.gen_dctr_file)}
                style={{
                  display: "flex",
                  flexDirection: "Column",
                  gap: "4px",
                  alignItems: "center",
                }}
              >
                <img
                  src={`${DocImgBaseUrl}${showDataAcc?.gen_dctr_file?.document_file_path}`}
                  alt=""
                  loading="lazy"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.outerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-file-earmark-image-fill" viewBox="0 0 16 16">
                                            <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707v5.586l-2.73-2.73a1 1 0 0 0-1.52.127l-1.889 2.644-1.769-1.062a1 1 0 0 0-1.222.15L2 12.292V2a2 2 0 0 1 2-2m5.5 1.5v2a1 1 0 0 0 1 1h2zm-1.498 4a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"/>
                                            <path d="M10.564 8.27 14 11.708V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-.293l3.578-3.577 2.56 1.536 2.426-3.395z"/>
                                            </svg>`;
                  }}
                />
                <small>{`${showDataAcc?.activity_type}ed at ${dayjs(showDataAcc?.gen_dctr_file?.created_at).format(
                  "DD-MM-YYYY, hh:mm:ss A"
                )}`}</small>
              </div>
              <div></div>
            </>
          ) : (
            <>
              {showDataAcc?.dataData?.map((item, index) => {
                return (
                  <div key={index} onDoubleClick={() => onFilterDocClick(item)} className="img_box">
                    {fileType == "image" ? (
                      <img
                        src={`${DocImgBaseUrl}${item?.document_file_path}`}
                        alt=""
                        loading="lazy"
                        onError={(e) => {
                          e.target.onerror = null; // prevent infinite loop
                          e.target.outerHTML = `
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-file-earmark-image-fill" viewBox="0 0 16 16">
                                                        <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707v5.586l-2.73-2.73a1 1 0 0 0-1.52.127l-1.889 2.644-1.769-1.062a1 1 0 0 0-1.222.15L2 12.292V2a2 2 0 0 1 2-2m5.5 1.5v2a1 1 0 0 0 1 1h2zm-1.498 4a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"/>
                                                        <path d="M10.564 8.27 14 11.708V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-.293l3.578-3.577 2.56 1.536 2.426-3.395z"/>
                                                        </svg>`;
                        }}
                      />
                    ) : (
                      <>
                        <div className="icon">
                          <PlayCircleFilled
                            style={{ fontSize: "32px", color: "red", position: "relative", top: "137px" }}
                          />
                        </div>
                        <video src={`${DocImgBaseUrl}${item?.document_file_path}`} />
                      </>
                    )}
                  </div>
                );
              })}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ShowImage;
